import React from "react";
import CategoryProductList from "./CategoryProductList";

const HornParts = () => {
  return (
    <CategoryProductList
      categoryName="Horn"
      categorySlug="horn"
    />
  );
};

export default HornParts;
